///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2026
//                           RXO Inc.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of RXO Inc. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import getPricingGridColumns from "./getPricingGridColumns";
import normalizeColumnFilterItemsForPersistence from "./normalizeColumnFilterItemsForPersistence";

export const MIN_LANE_SEARCH_CHARACTERS = 3;

export const filterPricingLanes = (
  state,
  {
    payload: {
      searchTerm,
      role,
      items,
      field,
      applyOnExistingFilters,
      range,
      analyticsGridView
    }
  }
) => {
  state.filtersApplied = false;
  const columns = getPricingGridColumns(role, state.division, analyticsGridView, state.isCoyoteBid);
  if (items && field) {
    state.columnFilters[field] =
      normalizeColumnFilterItemsForPersistence(items);
    filterPricingLanes(state, {
      payload: { searchTerm: state.searchTerm, role, analyticsGridView }
    });
    searchTerm = state.searchTerm;
  }
  if (range && field) {
    state.rangeFilters[field] = range;
    filterPricingLanes(state, {
      payload: { searchTerm: state.searchTerm, role, analyticsGridView }
    });
    searchTerm = state.searchTerm;
  }
  if (applyOnExistingFilters) {
    searchTerm = state.searchTerm;
  }
  const trimmedSearchLen = String(searchTerm ?? "").trim().length;
  if (state.lanes && state.lanes.length) {
    if (trimmedSearchLen === 0) {
      state.lanes.forEach(lane => {
        lane.metaData.matched = true;
      });
      state.searchTerm = "";
    } else if (trimmedSearchLen >= MIN_LANE_SEARCH_CHARACTERS) {
      state.filtersApplied = true;
      state.searchTerm = searchTerm;
      const needle = searchTerm.toLowerCase().trim();
      state.lanes.forEach(lane => {
        lane.metaData.matched = columns.some(column => {
          const value = column.format
            ? column.format(lane[column.field])
            : lane[column.field];
          return value &&
            value.toString &&
            value.toString().toLowerCase().indexOf(needle) !== -1
            ? true
            : false;
        });
      });
    } else {
      state.lanes.forEach(lane => {
        lane.metaData.matched = true;
      });
      state.searchTerm = searchTerm;
    }
  } else {
  }
  if (!applyOnExistingFilters) {
    state.offset = 0;
  }
  const { columnFilters, lanes, rangeFilters } = state;

  for (const field in columnFilters) {
    if (columnFilters[field].some(cf => cf.selected)) {
      state.filtersApplied = true;
      lanes
        .filter(l => l.metaData.matched)
        .forEach(l => {
          const column = columns.find(c => c.field === field);
          const value = column.format ? column.format(l[field]) : l[field];
          l.metaData.matched = columnFilters[field].some(
            cf => cf.selected && value === cf.value
          );
        });
    }
  }

  for (const field in rangeFilters) {
    const minValue = parseFloat(rangeFilters[field].minValue);
    const maxValue = parseFloat(rangeFilters[field].maxValue);
    state.filtersApplied = true;
    lanes
      .filter(l => l.metaData.matched)
      .forEach(l => {
        const column = columns.find(c => c.field === field);
        const value = column.format ? column.format(l[field]) : l[field];
        l.metaData.matched = parseFloat(value) >= minValue && value <= maxValue;
      });
  }
};

export default filterPricingLanes;
